import { takeLatest } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { createBooth, updateBooth } from '../api';
import { handleFormSubmit } from './helpers/handle-api-form-call';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* processSaveBooth(action: any) {
  const { data, formikActions } = action;
  const { id, serviceProviderId } = data;
  yield handleFormSubmit({
    id,
    formikActions,
    updateFn: async () => updateBooth(id, { serviceProviderId, ...data }),
    createFn: async () => createBooth({ serviceProviderId, ...data })
  });
}

export default function* saveBoothSaga() {
  yield takeLatest(AT.SAVE_BOOTH_SAGA, processSaveBooth);
}
